export default "__VITE_ASSET__DizbXLmf__"